import { instance } from 'three/examples/jsm/nodes/shadernode/ShaderNodeElements';

class MasterItemCollection{
  symbol_2d_code:string = "";
  symbol_3d_code:string = "";
  symbol_type:string = "";
  symbol_name:string = "";
  item_id:string = "";
  item_name:string = "";
  item_width:number = 0;
  item_height:number = 0;
  item_depth:number = 0;
  item_thumb_path:string = "";
  item_part_number:string = "";
  item_unit_price:number = 0;
  item_unit:string = "";
  item_memo:string = "";
  item_maker_name:string = "";
  item_sub_category:string = "";


  /**
   * コンストラクタ
   */
  constructor( data:any = null ) {
    if( !data ) return;
    this.symbol_2d_code = data.symbol_2d_code;
    this.symbol_3d_code = data.symbol_3d_code;
    this.symbol_type = data.symbol_type;
    this.symbol_name = data.symbol_name;
    this.item_id = data.item_id;
    this.item_name = data.item_name;
    this.item_width = data.item_width;
    this.item_height = data.item_height;
    this.item_depth = data.item_depth;
    this.item_thumb_path = data.item_thumb_path;
    this.item_part_number = data.item_part_number;
    this.item_unit_price = data.item_unit_price;
    this.item_unit = data.item_unit;
    this.item_memo = data.item_memo;
    this.item_maker_name = data.item_maker_name;
    this.item_sub_category = data.item_sub_category;

    //null文字変換
    for( let param in this ){
      if( !this[param] ) {
        switch (param){
          case "item_width":
          case "item_height":
          case "item_depth":
          case "item_unit_price":
            this[param as string] = 0;
            break;
          default:
            this[param as string] = "";
            break;
        }
      }
    }
  }
}
export default MasterItemCollection;
